(() => {
  'use strict';
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const $ = selector => root.querySelector(selector);
    const ref = name => $(`[data-ref="${name}"]`);
    const storageKey = 'tailhigh-contact-draft:' + location.pathname;
    const readDraft = () => { try { const d = JSON.parse(sessionStorage.getItem(storageKey)); return d && Date.now() - d.at < 3600000 ? d : null; } catch (_) { return null; } };
    const success = $('[data-contact-success]');
    if (success) {
      try { sessionStorage.removeItem(storageKey); } catch (_) {}
      root.classList.add('th-is-complete');
      requestAnimationFrame(() => { success.focus({preventScroll:true}); success.scrollIntoView({block:'start'}); });
      return;
    }
    const form = $('.contact-form'), type = ref('contact-type'), area = ref('dynamic-area');
    if (!form || !type || !area) return;
    const review = $('.th-review'), status = $('.th-status'), send = $('.th-send');
    const typePanel = type.closest('.form-section');
    const preview = root.dataset.preview === 'true';
    let pending, submitting = false, nativeSubmit = false;
    const focus = element => { element.focus(); element.scrollIntoView({ block: 'start', behavior: 'auto' }); };
    const message = (text, error = true, heading = '') => {
      status.hidden = false; status.className = `th-status ${error ? 'error-box' : 'success-box'}`;
      status.replaceChildren();
      if (heading) { const strong=document.createElement('strong'); strong.textContent=heading;status.append(strong,document.createElement('br')); }
      status.append(document.createTextNode(text)); focus(status);
    };
    const saveDraft = () => {
      const values = [...form.querySelectorAll('[name^="contact["]')].filter(el => el.name !== 'contact[body]').map(el => ({name:el.name,value:el.value,checked:el.checked}));
      try { sessionStorage.setItem(storageKey, JSON.stringify({at:Date.now(),values})); } catch (_) {}
    };
    const unlock = () => { submitting=false; nativeSubmit=false;send.disabled=false;$('.th-back').disabled=false;send.textContent='この内容で送信する';form.removeAttribute('aria-busy'); };
    const clone = name => ref(name).content.cloneNode(true);
    const completeCommon = () => area.querySelectorAll('.common-fields').forEach(el => el.replaceWith(clone('tpl-common-fields')));
    const friendly = key => ({name:'お名前',email:'メールアドレス',体重_kg:'体重（kg）',首周り_cm:'首周り（cm）',胸囲_cm:'胸囲（cm）',背丈_cm:'背丈（cm）'}[key] || key.replace(/_/g, ' '));
    function clearReview() { review.hidden = true; typePanel.hidden = false; area.hidden = false; status.hidden = true; }
    type.addEventListener('change', () => {
      clearReview(); pending = null;
      if (!type.value) { area.replaceChildren(); return; }
      const template = ref(`tpl-${type.value}`);
      if (!template) return;
      area.replaceChildren(template.content.cloneNode(true)); completeCommon();
      if (type.value === 'size-exchange') {
        area.querySelectorAll('input[type="radio"]').forEach(radio => radio.addEventListener('change', () => {
          const detail = ref('exchange-detail');
          if (radio.value === 'hybrid') detail.replaceChildren(clone('tpl-exchange-hybrid'));
          else {
            const texts = { wear: '商品ページに記載の通り、ウェア類はサイズ違いなどお客様都合によるサイズ交換を承っておりません。', lead: 'リード類はサイズ展開がないため、サイズ交換の対象外です。', other: '原則としてサイズ交換対象外です。サイズ交換以外の内容で確認が必要な場合は、該当する種別を選択してください。' };
            const box = document.createElement('p'); box.className = 'closed-box'; box.textContent = texts[radio.value]; detail.replaceChildren(box);
          }
        }));
      }
    });
    function showReview() {
      if (submitting || !review.hidden) return;
      // Reject non-submittable branches even when Enter triggers form submission.
      if (!area.querySelector('button[data-review-trigger]') || !form.reportValidity()) return;
      const fields = {};
      for (const [name, value] of new FormData(form)) {
        const key = /^contact\[(.+)\]$/.exec(name)?.[1];
        if (key && key !== 'お問い合わせ種別') fields[key] = String(value).trim();
      }
      pending = { type: type.value, fields };
      const list = $('.th-review-list'); list.replaceChildren();
      const rows = [['お問い合わせ種別', type.selectedOptions[0].textContent], ...Object.entries(fields).map(([key, value]) => [friendly(key), key === 'サイズ交換カテゴリ' ? 'Hybrid Harness' : value || '（未入力）'])];
      rows.forEach(([key, value]) => {
        const dt = document.createElement('dt'), dd = document.createElement('dd');
        dt.textContent = key; dd.textContent = value; list.append(dt, dd);
      });
      status.hidden = true; area.hidden = true; typePanel.hidden = true; review.hidden = false;
      send.disabled = false; focus(review);
    }
    form.addEventListener('click', event => {
      if (event.target.closest('[data-review-trigger]')) { event.preventDefault(); showReview(); }
    });
    form.addEventListener('keydown', event => {
      if(event.key === 'Enter' && !event.isComposing && event.target.tagName === 'INPUT') {
        event.preventDefault(); if(!submitting) showReview();
      }
    });
    form.addEventListener('submit', event => {
      if(nativeSubmit) return;
      event.preventDefault(); event.stopImmediatePropagation(); showReview();
    }, true);
    $('.th-back').addEventListener('click', () => { if (!submitting) { clearReview(); focus(type); } });
    send.addEventListener('click', () => {
      if (submitting || !pending) return;
      if (!navigator.onLine) { message('通信できません。入力内容は保持されています。接続を確認して再度送信してください。'); return; }
      if (preview) {
        submitting=true;send.disabled=true;$('.th-back').disabled=true;send.textContent='送信中…';
        form.setAttribute('aria-busy','true');
        root.dispatchEvent(new CustomEvent('th-preview-send'));
        return;
      }
      // The review step never sends. Only this final action permits Shopify's native POST.
      if (!area.querySelector('button[data-review-trigger]')) return;
      saveDraft();
      form.querySelector('[data-generated-body]')?.remove();
      form.setAttribute('aria-busy','true');
      submitting = true; send.disabled = true; $('.th-back').disabled = true;
      send.textContent = '送信中…';
      const body = document.createElement('textarea');
      body.dataset.generatedBody = 'true';
      body.name = 'contact[body]'; body.hidden = true;
      body.value = [['お問い合わせ種別', type.selectedOptions[0].textContent],
        ...Object.entries(pending.fields).map(([key, value]) => [friendly(key), key === 'サイズ交換カテゴリ' ? 'Hybrid Harness' : value])]
        .map(([key,value]) => `${key}：${value}`).join('\n');
      form.append(body);
      nativeSubmit = true;
      // requestSubmit preserves Shopify's submit-event spam protection and challenge flow.
      try { form.requestSubmit(); } catch (_) { unlock(); message('送信処理を開始できませんでした。入力内容を確認して再度お試しください。'); }
    });
    if(preview)root.addEventListener('th-preview-error',()=>{unlock();message('入力内容は保存されています。もう一度送信するか、入力内容を修正してください。',true,'送信できませんでした。');});
    type.disabled = false;
    const draft = readDraft();
    if (draft) {
      const kind = draft.values.find(v => v.name === type.name);
      if (kind) { type.value=kind.value;type.dispatchEvent(new Event('change')); }
      // Radio selection builds the conditional exchange fields before restoring their values.
      for (const v of draft.values) {
        const el=[...form.elements].find(el=>el.type==='radio' && el.name===v.name && el.value===v.value);
        if(el && v.checked){el.checked=true;el.dispatchEvent(new Event('change'));}
      }
      for(const v of draft.values) for(const el of [...form.elements].filter(el=>el.name===v.name)) {
        if(el.type==='checkbox' || el.type==='radio'){if(el.value===v.value)el.checked=!!v.checked;}else el.value=v.value;
      }
      message('送信済みかご不明な場合は、重複送信を避けるため、受付状況をご確認のうえ再送してください。',true,'前回の入力内容を復元しました。');
    }
    form.addEventListener('input',saveDraft);form.addEventListener('change',saveDraft);
    const serverError=$('[data-contact-error]');
    if(serverError)requestAnimationFrame(()=>focus(serverError));
    window.addEventListener('pageshow',event=>{if(event.persisted){unlock();message('送信済みかご不明な場合は、重複送信を避けるため、受付状況をご確認のうえ再送してください。',true,'前回の入力内容を復元しました。');}});

  }
  const initialize = () => document.querySelectorAll('.th-contact').forEach(init);
  initialize(); document.addEventListener('shopify:section:load', initialize);
  // Returning from Shopify's challenge/error page restores an operable review screen.

})();
